var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 55,
    viewBox: "0 0 40 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 352",
    d: "M37 3H3V37L20 51L37 37V3Z",
    fill: "#230047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 352 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H40V38.4158L20 54.8864L0 38.4158V0ZM37 3V37L20 51L3 37V3H37Z",
    fill: "#410096"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 391",
    d: "M20 41L3 31V37L20 51L37 37V31L20 41Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 392",
    d: "M20 27L3 17V23L20 33L37 23V17L20 27Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 364",
    d: "M37 3H3V9L20 19.5L37 9V3Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 385",
    d: "M3 36.5V8L7 11V39.5L3 36.5Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 386",
    d: "M37 36.5V8L33 11V39.5L37 36.5Z",
    fill: "#F0B90B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/A.7b16ec8b.svg";
export { ForwardRef as ReactComponent };